import { useState } from "react";
import { EnvelopeSimple, Check, Lightning } from "@phosphor-icons/react";
import axios from "axios";
import { API } from "@/App";

export function NewsletterSignup({ source = "generic", variant = "inline", className = "" }) {
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState("idle"); // idle, loading, success, error
  const [errorMsg, setErrorMsg] = useState("");

  const subscribe = async (e) => {
    e.preventDefault();
    if (!email || !email.includes("@")) return;
    setStatus("loading");
    setErrorMsg("");
    try {
      await axios.post(`${API}/newsletter/subscribe`, { email, source });
      setStatus("success");
    } catch (err) {
      setStatus("error");
      setErrorMsg(err.response?.data?.detail || "Something went wrong. Please try again.");
    }
  };

  if (status === "success") {
    return (
      <div className={`flex items-center gap-2 p-4 border border-[#4ade80]/30 bg-[#4ade80]/5 rounded-sm ${className}`} data-testid="newsletter-success">
        <Check size={16} weight="bold" className="text-[#4ade80] shrink-0" />
        <p className="text-sm text-[#4ade80] font-semibold">You are in. Watch your inbox for the next update.</p>
      </div>
    );
  }

  if (variant === "compact") {
    return (
      <form onSubmit={subscribe} className={`flex gap-2 ${className}`} data-testid="newsletter-form">
        <div className="relative flex-1">
          <EnvelopeSimple size={14} className="absolute left-3 top-1/2 -translate-y-1/2 text-[#555]" />
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Your email for weekly updates"
            className="w-full h-9 pl-8 pr-3 bg-[#171717] border border-[#333] text-white text-xs rounded-sm placeholder:text-[#555] focus:border-[#ccff00] focus:outline-none"
            data-testid="newsletter-email"
            required
          />
        </div>
        <button
          type="submit"
          disabled={status === "loading"}
          className="h-9 px-4 bg-[#ccff00] text-black text-[11px] font-bold rounded-sm hover:bg-[#b8e600] transition-colors disabled:opacity-50 shrink-0"
          data-testid="newsletter-submit"
        >
          {status === "loading" ? "..." : "SUBSCRIBE"}
        </button>
        {status === "error" && <p className="text-[10px] text-[#ff3b30] mt-1">{errorMsg}</p>}
      </form>
    );
  }

  return (
    <div className={`border border-[#262626] bg-[#171717] p-5 rounded-sm ${className}`} data-testid="newsletter-signup">
      <div className="flex items-center gap-2 mb-2">
        <Lightning size={14} weight="fill" className="text-[#ccff00]" />
        <h3 className="text-xs font-bold text-white uppercase">GET THE WEEKLY DYNASTY UPDATE</h3>
      </div>
      <p className="text-[10px] text-[#888] mb-3">Value movers, trade targets, and data drops — straight to your inbox every week. Free, no spam, unsubscribe anytime.</p>
      <form onSubmit={subscribe} className="flex gap-2">
        <div className="relative flex-1">
          <EnvelopeSimple size={14} className="absolute left-3 top-1/2 -translate-y-1/2 text-[#555]" />
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="your@email.com"
            className="w-full h-10 pl-8 pr-3 bg-[#0a0a0a] border border-[#333] text-white text-sm rounded-sm placeholder:text-[#555] focus:border-[#ccff00] focus:outline-none"
            data-testid="newsletter-email"
            required
          />
        </div>
        <button
          type="submit"
          disabled={status === "loading"}
          className="h-10 px-5 bg-[#ccff00] text-black text-[11px] font-bold rounded-sm hover:bg-[#b8e600] transition-colors disabled:opacity-50 shrink-0"
          data-testid="newsletter-submit"
        >
          {status === "loading" ? "Subscribing..." : "SUBSCRIBE"}
        </button>
      </form>
      {status === "error" && <p className="text-[10px] text-[#ff3b30] mt-2">{errorMsg}</p>}
      <p className="text-[9px] text-[#444] mt-2">By subscribing you agree to our <a href="/privacy" className="text-[#555] hover:text-[#888] no-underline underline">privacy policy</a>. Unsubscribe anytime.</p>
    </div>
  );
}
